<template>
  <nav class="nav" :class="{'sticky-nav': isSticky && !showBurger}">
    <router-link to="/" style="z-index: 20">
      <img
        @click="showBurger = false"
        alt="Nordic Performance Center Boden Logo"
        :src="(isSticky && !showBurger) ? 'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Flogos%2FNPCPowerClubLogoSmallWhite.png?alt=media' :
'https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/NPCPowerClub%2Flogos%2FNPCPowerClubLogoSmallWhite.png?alt=media'"      />
    </router-link>

    <nav class="menu desktop-menu" v-show="!isMobile">
      <custom-button to="/" :class="{active : activeView === '/'}">
        <span>Hem</span>
      </custom-button>
        <custom-button to="/about" :class="{active : activeView === '/about'}">
        <span>Om oss</span>
      </custom-button>
    </nav>
    <nav class="menu snd-menu" v-show="!isMobile">
         <custom-button to="/kontakt" :class="{active : activeView === '/kontakt'}">
        <span>Kontakta oss</span>
      </custom-button>
    </nav>

    <transition name="slide">
      <nav class="mobile-menu" v-if="isMobile && showBurger" @click="toggleBurger">
        <custom-button style="margin-top: 110px; width: 100%; text-align: left;" to="/" :class="{active : activeView === '/'}">
          <span>Hem</span>
        </custom-button>
        <custom-button style="width: 100%; text-align: left;" to="/about" :class="{active : activeView === '/about'}">
           <span>Om oss</span>
        </custom-button>
        <custom-button style="width: 100%; text-align: left;" to="/kontakt" :class="{active : activeView === '/kontakt'}">
          <span>Kontakta oss</span>
        </custom-button>
        <img style="position: absolute; bottom: 0%; left: 0px; width: 100%; border: none; height: auto;" src="https://firebasestorage.googleapis.com/v0/b/nordicperformancecenter-57600.appspot.com/o/website%2Fwebsite%2FNPCHexagons.png?alt=media"/>
      </nav>
    </transition>

    <font-awesome-icon
      @click="toggleBurger"
      :icon="['fas', 'bars']"
      class="hamburger-icon"
      style="color: white;"
      v-if="!showBurger"
    />
    <div @click="toggleBurger" style="color: white;" class="close-x hamburger-icon" v-else></div>
  </nav>
</template>

<script>
import CustomButton from '@/components/Button.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CustomButton
  },
  data () {
    return {
      showBurger: false,
      isSticky: true,
      isHomeView: true
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    activeView () {
      return this.$route.path
    }
  },
  watch: {
  },
  methods: {
    ...mapActions([]),
    toggleBurger () {
      this.showBurger = !this.showBurger
    },
    handleScroll () {
      this.isSticky = false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
@import '../../styles/variables';
.nav {
  background: black;
  box-shadow: @shadow;
  display: flex;
  flex-direction: row;
  padding: 1em;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 98;
  height: @navbar-height;
  img {
    z-index: 20;
    height: 38px;
    margin-top: 3px;
    margin-right: @side-margin;
  }
}

.sticky-nav {
  position: absolute !important;
  box-shadow: none !important;
}

.desktop-menu {
  display: flex;
  flex: 1;
}
.snd-menu {
  display: flex;
  margin-left: auto;
}
.snd-menu *,
.desktop-menu * {
  margin-bottom: 0; // TODO overrides button style but not best practice
}

.mobile-menu {
  background: black;
  color: @color-grey-darkest;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  a,
  button {
    font-family: @font-family;
    font-size: @font-size-large;
  }
  a.active span,
  button.active span {
    border-bottom: 5px solid @color-grey-darkest;
    width: 100%;
  }
}

.hamburger-icon {
  cursor: pointer;
  width: calc(@navbar-height - 20px);
  height: calc(@navbar-height - 20px);
  z-index: 20;
}
.close-x {
  margin-top: -46px;
  margin-right: -1px;
  font-size: 80px;
}
.close-x:hover {
  cursor: pointer;
}
.close-x:after {
  content: '\00d7'; /* This will render the 'X' */
}

.menu a span,
.menu button span,
.menu a {
  position: relative;
  color: white
}

.menu a span:after,
.menu button span:after {
  content: '';
  display: block;
  border-bottom: 3px solid;
  top: 22px;
  width: 0;
  position: absolute;
  left: 0;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
}
.menu a:hover span:after,
.menu button:hover span:after,
.menu a.active span:after,
.menu button.active span:after {
  width: 100%;
}
.menu a:hover, button:hover {
  text-decoration: none;
}

.isMobile {
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  a,
  button {
    font-size: @font-size-large;
  }
}

.nav,
.isMobile {
  transition: 0.3s;
}
// TODO: Fucking få svg storlek att ändras i css

@media only screen and (min-width: @md-min-width) {
  .login {
    display: none;
  }
  .hamburger-icon {
    display: none;
  }
  .main-menu,
  .snd-menu > :not(:first-child) {
    display: block;
  }
}
</style>
